import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { get, isEmpty } from 'lodash';
import eatTransactionWithEatEventsQuery from '../../graphql/eatTransactionWithEatEventsQuery';
import client from '../../apollo';

import { generateCSVFile } from '../../utilities/CsvUtil';
import { handleEatExportData } from './EatExportData';

class ExportEAT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExport: false,
      exportFileName: 'export_EAT',
    };
  }

  handleDataExportToCSV = () => {
    this.setState({
      isExport: true,
    });

    const {
      vin,
      dealerNumber,
      purchaseLocation,
      auction,
      saleDate,
    } = this.props;

    client
      .query({
        query: eatTransactionWithEatEventsQuery,
        variables: {
          vin,
          dealerNumber,
          purchaseLocation,
          auction,
          saleDate,
        },
      })
      .then(({ data }) => {
        const result = get(data, 'eatTransactionWithEatEventData');

        if (!isEmpty(result)) {
          const eatExportData = handleEatExportData(result);

          const { exportFileName } = this.state;
          generateCSVFile(eatExportData, exportFileName);

          setTimeout(() => {
            this.setState({
              isExport: false,
            });
          }, 400);
        }
      });
  };

  render() {
    const { isExport } = this.state;
    return (
      <div>
        <Button
          color='blue'
          onClick={this.handleDataExportToCSV}
          disabled={isExport}
        >
          Export CSV
        </Button>
      </div>
    );
  }
}

ExportEAT.propTypes = {
  vin: PropTypes.string,
  dealerNumber: PropTypes.string,
  purchaseLocation: PropTypes.string,
  auction: PropTypes.string,
  saleDate: PropTypes.string,
};

ExportEAT.defaultProps = {
  vin: '',
  dealerNumber: '',
  purchaseLocation: '',
  auction: '',
  saleDate: '',
};

export default ExportEAT;
